import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../components/global/appContext";
import TabContainer from "../../components/components/TabContainer";

import MapSettings from "./pages/map/Edit";

import TagsIndex from "./pages/tags/Index";
import TagsNew from "./pages/tags/New";
import TagsEdit from "./pages/tags/Edit";

import FieldsIndex from "./pages/customFields/Index";
import FieldsNew from "./pages/customFields/New";
import FieldsEdit from "./pages/customFields/Edit";

import LanguageSettings from "./pages/languages/Edit";

import PlanShow from "./pages/plan/Show";
import PlanEdit from "./pages/plan/Edit";
import PlanConfirmation from "./pages/plan/Confirmation";

import {
  GlobeMinor,
  ProductsMinor,
  TypeMinor,
  PlanMinor,
  CirclePlusOutlineMinor,
  AlertMinor,
  LanguageMinor,
} from "@shopify/polaris-icons";

export default function SettingsHome() {
  const { t } = useTranslation();
  const { plan } = useContext(AppContext);

  const planBadge = !plan ? t("settings.planBadges.trial") : plan.trial_end ? t("settings.planBadges.endsSoon") : null;

  const sections = [
    {
      // fill: true,
      items: [
        {
          url: "/settings/map",
          label: t("settings.navigation.map"),
          icon: GlobeMinor,
        },
        {
          label: t("settings.navigation.tags"),
          url: "/settings/tags",
          icon: ProductsMinor,
          secondaryActions: [
            {
              url: "/settings/tags/new",
              accessibilityLabel: t("settings.navigation.addTag"),
              icon: CirclePlusOutlineMinor,
            },
          ],
        },
        {
          label: t("settings.navigation.customFields"),
          url: "/settings/fields",
          icon: TypeMinor,
          secondaryActions: [
            {
              url: "/settings/fields/new",
              accessibilityLabel: t("settings.navigation.addField"),
              icon: CirclePlusOutlineMinor,
            },
          ],
        },
        {
          label: t("settings.navigation.languages"),
          url: "/settings/languages",
          icon: LanguageMinor,
        },
      ],
    },
    {
      separator: true,
      items: [
        {
          label: t("settings.navigation.plan"),
          url: "/settings/plan",
          icon: PlanMinor,
          badge: planBadge,
        },
      ],
    },
  ];

  return (
    <TabContainer
      sections={sections}
    >
    <Routes>
            <Route index element={<Navigate to= 'map' /> } />

            <Route path="map" element={<MapSettings />} />

            <Route path="tags" element={<TagsIndex />} />
            <Route path="tags/new" element={<TagsNew />} />
            <Route path="tags/:id" element={<TagsEdit />} />

            <Route path="fields" element={<FieldsIndex />} />
            <Route path="fields/new" element={<FieldsNew />} />
            <Route path="fields/:id" element={<FieldsEdit />} />

            <Route path="languages" element={<LanguageSettings />} />

            <Route path="plan" element={<PlanShow />} />
            <Route path="plan/edit" element={<PlanEdit />} />
            <Route path="plan/confirmation" element={<PlanConfirmation />} />
        </Routes>
  </TabContainer>
  );
}
